"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M8.5 1.5H3.5C2.39543 1.5 1.5 2.39543 1.5 3.5V8.5M8.5 1.5H15.5M8.5 1.5V22.5M15.5 1.5H20.5C21.6046 1.5 22.5 2.39543 22.5 3.5V8.5M15.5 1.5V22.5M8.5 22.5H3.5C2.39543 22.5 1.5 21.6046 1.5 20.5V15.5M8.5 22.5H15.5M15.5 22.5H20.5C21.6046 22.5 22.5 21.6046 22.5 20.5V15.5M22.5 15.5V8.5M22.5 15.5H1.5M22.5 8.5H1.5M1.5 15.5V8.5", stroke: "black" }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M11.3333 2H4C2.89543 2 2 2.89543 2 4V11.3333M11.3333 2H20.6667M11.3333 2V30M20.6667 2H28C29.1046 2 30 2.89543 30 4V11.3333M20.6667 2V30M11.3333 30H4C2.89543 30 2 29.1046 2 28V20.6667M11.3333 30H20.6667M20.6667 30H28C29.1046 30 30 29.1046 30 28V20.6667M30 20.6667V11.3333M30 20.6667H2M30 11.3333H2M2 20.6667V11.3333", stroke: "black", strokeWidth: "1.5" }, void 0) }), void 0));
};
var GridIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.GridIcon = GridIcon;
//# sourceMappingURL=GridIcon.js.map